<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeIndex"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import { localRead } from "@/utils/tools";
export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      routes: [],
      activeIndex: ""
    };
  },
  mounted() {
    this.getRoutes();

  },

  methods: {
    getRoutes() {
      if (window.SITE_CONFIG["dynamicMenuRoutes"].length != 0) {
        this.routes = this.$router.options.routes.concat(
          window.SITE_CONFIG["dynamicMenuRoutes"]
        );
      } else {
        this.routes = this.$router.options.routes.concat(
          JSON.parse(localRead(this.$route.query.label + "_menus"))
        );
      }
      this.checkPermTree(this.routes)
    },
    checkPermTree(permData){
        let routerArr = []
        let _this = this;
        permData.forEach(function(p){
          if(p.hidden == 1){
            p.hidden = false
          }else if(p.hidden == 2){
            p.hidden = true
          }
          if (p.children && p.children.length > 0) {
            _this.checkPermTree(p.children);
          }
        });
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  watch: {
    "$route.query.label": function(val) {
      this.routes = this.$router.options.routes.concat(
        window.SITE_CONFIG["dynamicMenuRoutes"]
      );
      this.checkPermTree(this.routes)
    },
    $route() {
      let i = this.$route.path;

      setTimeout(() => {
        //路由跳转
        this.activeIndex = i + "?label=" + this.$route.query.label;
      }, 100);
    }
  }
};
</script>
